import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import { ENABLE_REMOTE_LOGIN_FAILURE, ENABLE_REMOTE_LOGIN_REQUEST, ENABLE_REMOTE_LOGIN_SUCCESS } from 'onboarding/stylists/actions';

const enableRemoteLogin = ({ salonId, stylistId }) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    endpoint: `salon/${salonId}/stylist/${stylistId}/enable_login/`,
    config: { method: 'POST', headers: { 'Content-Type': 'application/json' } },
    types: [ENABLE_REMOTE_LOGIN_REQUEST, ENABLE_REMOTE_LOGIN_SUCCESS, ENABLE_REMOTE_LOGIN_FAILURE],
  },
});

// noinspection JSUnusedGlobalSymbols
export default enableRemoteLogin;
